import { find } from "lodash";

import type { Space, SpaceGroup } from "../types";

export const isCollapsed = ({
  spaceGroupId,
  currentCommunityMember,
}: {
  spaceGroupId: number;
  currentCommunityMember: any;
}) => currentCommunityMember?.hidden_space_group_ids?.includes(spaceGroupId);

export const canManageSpaceGroups = ({ spaceGroup }: { spaceGroup: any }) =>
  spaceGroup?.policies?.can_manage_space_group;

export const canCreateSpaces = ({ spaceGroup }: { spaceGroup: any }) =>
  spaceGroup.policies?.can_create_space;

export const addSpacesToGroup = ({
  spaceGroup,
  spaces,
  spacesWithDetails = [],
}: {
  spaceGroup: SpaceGroup;
  spaces: Space[];
  spacesWithDetails?: any;
}) => {
  const spacesInGroup = spaces.filter(
    (space: any) => space.space_group_id == spaceGroup.id,
  );
  const spacesWithDetailsInGroup = spacesInGroup.map((space: any) => ({
    ...space,
    ...(find(spacesWithDetails, { id: space.id }) || {}),
  }));
  return {
    ...spaceGroup,
    spaces: spacesWithDetailsInGroup,
  };
};

export const isSpaceGroupMemberGrantedByPaywall = (accessType: string) =>
  accessType === "paywall";
